import * as THREE from 'three'
import React, { useRef } from 'react'
import { extend } from '@react-three/fiber'
import { Cylinder, Torus } from "@react-three/drei"
import Ring from './Ring'

import GradientMaterial from '../Shaders/GradientMaterial'
extend({GradientMaterial})

const PlaneBRLC = React.forwardRef((props,ref) => {
  return (
    <group ref={ref} {...props} dispose={null}>
      <Cylinder
        args={[1, 1, 0.1, 64]}
        rotation={[Math.PI*1.5-0.1,0,0]}
      >
        <meshPhongMaterial attach="material" color="#222222" />
      </Cylinder>
      <Ring rotation={[Math.PI*1.5 - 0.1,0,0]} position={[0,0,0.2]} color="#0000ff" r1={0.5} r2={0.6} res={32}>
        <gradientMaterial attach="material" uniforms-color1-value={'#FFC700'} uniforms-color2-value={'#00EF26'} />
      </Ring>
      <Ring rotation={[Math.PI*1.5 - 0.1,0,0]} position={[0,0,-0.2]} color="#0000ff" r1={0.5} r2={0.6} res={32}>
        <gradientMaterial attach="material" uniforms-color1-value={'#FFC700'} uniforms-color2-value={'#00EF26'} />
      </Ring>
      <Torus
        args={[10,0.2,8,64]}
        position={[0,0,0]}
        scale={[0.1,0.1,0.1]}
        rotation={[Math.PI*2-0.1,0,0]}
      >
        <meshPhongMaterial attach="material" color="#999999" />
      </Torus>
    </group>
  )
})

export default PlaneBRLC
